import instance from "../../api";

export const getDbInfo = () => {
  return instance(true)
    .get("/crm/db-info/")
    .then((res) => res?.data);
};
